import COMMON_ROUTES, { NETWORK_ALIASES } from '../common/routes'
import { ENABLED_ACCOUNT_TRANSFER_NETWORKS } from 'constants/app-config'

const TRANSFER_ACCOUNT_NETWORK_ALIASES = `(${ENABLED_ACCOUNT_TRANSFER_NETWORKS.join('|')})`

const mergedRoutes = {
  ...COMMON_ROUTES,

  SERVICES_NETWORK_TRANSFER_ACCOUNTS: `/:i18n/services/:networkType${NETWORK_ALIASES}/transfer-accounts`,
  SERVICES_NETWORK_ACCOUNT_TRANSFER: `/:i18n/:transferNetwork${TRANSFER_ACCOUNT_NETWORK_ALIASES}/transfer-account`,
  BILLING_ACCOUNT_TRANSFER_PAYMENT: `/:i18n/billing/:transferNetwork${TRANSFER_ACCOUNT_NETWORK_ALIASES}/transfer-account/:requestId([0-9]+)/payment`,

  SERVICES_NETWORK_LEAD_MANAGER: `/:i18n/services/:networkType${NETWORK_ALIASES}/lead-manager`,
  SERVICES_NETWORK_LEAD_MANAGER_JOURNAL: `/:i18n/services/:networkType${NETWORK_ALIASES}/lead-manager/journal`,
  SERVICES_NETWORK_LEAD_MANAGER_CREATE: `/:i18n/services/:networkType${NETWORK_ALIASES}/lead-manager/create`,
  SERVICES_NETWORK_LEAD_MANAGER_CREATE_WEBHOOK: `/:i18n/services/:networkType${NETWORK_ALIASES}/lead-manager/create-webhook`,
  SERVICES_NETWORK_LEAD_MANAGER_DUPLICATE: `/:i18n/services/:networkType${NETWORK_ALIASES}/lead-manager/:id([0-9]+)/duplicate`,
  AMO_CRM_CODE: '/amocrm/callback',

  ADVERTISERS: '/:i18n/advertisers',
  ADVERTISER_NEW: '/:i18n/advertisers/new',
  ADVERTISER_EDIT: '/:i18n/advertisers/:id([0-9]+)/edit',

  RECOMMENDATIONS: '/:i18n/recommendations',
  RECOMMENDATIONS_AUDITS: '/:i18n/recommendations/audits',
  RECOMMENDATIONS_AUDITS_VIEW: '/:i18n/recommendations/:type(audits)/:id',
  RECOMMENDATIONS_BENCHMARKS: '/:i18n/recommendations/benchmarks',
  RECOMMENDATIONS_BENCHMARKS_VIEW: '/:i18n/recommendations/:type(benchmarks)/:id',
  RECOMMENDATIONS_CAMPAIGNS: '/:i18n/recommendations/campaigns-recommendations',
  RECOMMENDATIONS_TYPE: '/:i18n/recommendations/campaigns-recommendations/:type',

  PULSE: '/:i18n/statistics/pulse',

  PARTNERS: '/:i18n/partners',
  PARTNERS_PROGRAM: '/partners-program',

  OFERTA: '/:i18n/oferta',

  MARKETPLACE_TOOLS: '/:i18n/marketplace-tools',
  MARKETPLACE_TOOLS_SUBSCRIBE: '/:i18n/marketplace-tools/:toolId([0-9]+)/subscribe',
  MARKETPLACE_TOOLS_ORDER_PAYMENT:
    '/:i18n/marketplace-tools/:toolId([0-9]+)/orders/:orderId([0-9]+)/pay',
  MARKETPLACE_TOOLS_SUBSCRIPTIONS: '/:i18n/marketplace-tools/:toolId([0-9]+)/subscriptions',
}

export { mergedRoutes as ROUTES }
